// extracted by mini-css-extract-plugin
module.exports = {"videoPlayButton":"videoPlayButton_videoPlayButton__xToxB","nonGddsVideoPlayButton":"videoPlayButton_nonGddsVideoPlayButton__E937R"};